"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get GetAsyncTaskStatusParams () {
        return GetAsyncTaskStatusParams;
    },
    get GetAsyncTasksByNameQuery () {
        return GetAsyncTasksByNameQuery;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const GetAsyncTaskStatusParams = _zod.z.object({
    id: _utilsisomorphic.transformObjectId
});
const GetAsyncTasksByNameQuery = _zod.z.object({
    taskName: _zod.z.string()
});
